import styled from 'styled-components';

export const StyledContent = styled.div`
  flex: 1;
  padding: 16px;
  padding-left: 24px;
  padding-bottom: ${props => props.theme.pageContent.paddingBottom};
  overflow-y: auto;
  overflow-x: auto;
  height: 100%;
  background: #f7f8f9;

  > .header {
    margin: -16px;
    padding: 16px;
  }
`;

export default styled.div`
  display: flex;
  flex: 1;
  overflow-y: auto;
  margin: 0;
  padding: 0;
  color: ${({ theme }) => theme.colors.panel.main.foreground};
  background-color: ${({ theme }) => theme.colors.panel.main.background};
`;
